export default "__VITE_ASSET__DcqiT9V$__"